module.exports = __webpack_public_path__ + "static/Flowchart-ec7b65e89f48a0e12dc1e92ef4d5561b.svg";